import { Dropdown } from 'components/form/inputs/Dropdown'
import { TextInput } from 'components/form/inputs/TextInput'
import { useNodePropertyPanel } from 'features/processFlowDiagrams/components/nodes/propertyPanel/NodePropertyPanelContext'
import {
  ColorHexInput,
  ColorInput,
  ColorInputWrapper,
  FormSection,
  labelPositionOptions,
  SectionTitle,
  shapeStyleOptions,
} from 'features/processFlowDiagrams/components/nodes/propertyPanel/StylesAndHelper'
import React from 'react'
import { PfdLabelPosition, PfdShapeStyle } from 'types'

/** Label, label position, shape/text color, and shape style controls. */
export const AppearanceSection: React.FC = () => {
  const {
    selectedNodeId,
    label,
    labelPosition,
    shapeColor,
    textColor,
    shapeStyle,
    handleLabelChange,
    handleLabelPositionChange,
    handleShapeColorChange,
    handleTextColorChange,
    handleShapeStyleChange,
  } = useNodePropertyPanel()

  return (
    <>
      <FormSection>
        <SectionTitle>Label</SectionTitle>
        <TextInput
          value={label}
          onChange={(e) => handleLabelChange(e.target.value)}
          placeholder='Label'
        />
      </FormSection>
      <FormSection>
        <SectionTitle>Label Position</SectionTitle>
        <Dropdown
          key={`${selectedNodeId}-label-position`}
          options={labelPositionOptions}
          defaultValue={labelPosition}
          onValueChange={(value) =>
            handleLabelPositionChange(value as PfdLabelPosition)
          }
          placeholder='Select position'
        />
      </FormSection>
      <FormSection>
        <SectionTitle>Shape Color</SectionTitle>
        <ColorInputWrapper>
          <ColorInput
            type='color'
            value={shapeColor || '#ffffff'}
            onChange={(e) => handleShapeColorChange(e.target.value)}
          />
          <ColorHexInput
            type='text'
            value={shapeColor}
            onChange={(e) => handleShapeColorChange(e.target.value)}
            placeholder='#ffffff or empty for default'
          />
        </ColorInputWrapper>
      </FormSection>
      <FormSection>
        <SectionTitle>Text Color</SectionTitle>
        <ColorInputWrapper>
          <ColorInput
            type='color'
            value={textColor || '#ffffff'}
            onChange={(e) => handleTextColorChange(e.target.value)}
          />
          <ColorHexInput
            type='text'
            value={textColor}
            onChange={(e) => handleTextColorChange(e.target.value)}
            placeholder='#ffffff or empty for default'
          />
        </ColorInputWrapper>
      </FormSection>
      <FormSection>
        <SectionTitle>Shape Style</SectionTitle>
        <Dropdown
          key={`${selectedNodeId}-shape-style`}
          options={shapeStyleOptions}
          defaultValue={shapeStyle}
          onValueChange={(value) =>
            handleShapeStyleChange(value as PfdShapeStyle)
          }
          placeholder='Select style'
        />
      </FormSection>
    </>
  )
}
